import { BaseDownloadMessage } from '~/core/startDownload'

import { MutationOperations } from './logic'

export const InspectionQualityDocumentsDownload = (props: {
    jobRequestId: number
    notificationKey?: string
}) => {
    const { jobRequestId, notificationKey } = props
    const mutationOperation = MutationOperations()

    return (
        <BaseDownloadMessage
            openCompleteNotification
            notificationKey={notificationKey}
            fetchZip={async () => {
                const response =
                    await mutationOperation.downloadInspectionDocuments(
                        jobRequestId,
                    )

                return response?.data?.createJobRequestZipDownloadJob?.url
            }}
        />
    )
}
